import { Injectable } from '@angular/core';

import { Ampli, IdentifyProperties } from '../ampli';
import { ampli } from '../ampli/index';


@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  ampliClient?: Ampli['client'];

  constructor() {
    if (ampli.isLoaded) {
      this.ampliClient = ampli.client;
    } else {
      console.info('Amplitude tracking disabled.');
    }
  }

  setUserId(userId: string): void {
    if (!this.ampliClient) {
      console.log(`Amplitude tracking disabled. User ID not set: ${userId}`);

      return;
    }
    this.ampliClient?.setUserId(userId);
  }

  setUserProperties(userId: string, properties: IdentifyProperties): void {
    if (!this.ampliClient) {
      console.log(`Amplitude tracking disabled. User properties not set for user ID: ${userId}`, properties);

      return;
    }
    ampli.identify(userId, properties);
  }
}
